import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import QRCode from "react-qr-code";
import Subheading from "../../../components/common/Subheading";
import { authenticateUserPassword, generateOtpKey } from "../../../services/auth/authorisation";
import FormField from "./FormField";
import FormSection from "./FormSection";

/**
 * MfaConfiguration component
 *
 * A reusable component for managing Multi-Factor Authentication (MFA) settings
 *
 * @param {Object} props - Component props
 * @param {function} props.showAlert - Function to show alerts
 * @returns {JSX.Element} MFA configuration form component
 */
function MfaConfiguration({ showAlert }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [qrValue, setQrValue] = useState("");

  const onPassword = (e) => setCurrentPassword(e.target.value);
  const onOtp = (e) => setOtpValue(e.target.value);

  const onGenerateKey = async () => {
    const authenticated = await authenticateUserPassword(currentPassword, otpValue);
    if (authenticated.msg !== "success") {
      showAlert("error", authenticated.msg);
      return;
    }

    const otpKey = await generateOtpKey();
    setQrValue(otpKey.provisioning_uri);
    showAlert("success", "MFA key generated successfully");
  };

  return (
    <Grid container direction="column" px={"10%"} width={"100%"} spacing={3}>
      <Subheading text="Multi Factor Authentication" sx={{ mb: 3, fontSize: "1.5rem" }} />

      <FormSection title="Authentication Required">
        <FormField
          fieldLabel="Current Password"
          type="password"
          value={currentPassword}
          onChange={onPassword}
          label="Current Password"
        />
        <FormField fieldLabel="OTP" value={otpValue} onChange={onOtp} label="OTP" />
      </FormSection>

      <Box display={"flex"} justifyContent={"center"} mt={2}>
        <Button variant="contained" size="large" sx={{ py: 1.2, px: 4, borderRadius: 2 }} onClick={onGenerateKey}>
          Generate MFA Key
        </Button>
      </Box>

      {/* QR code section - only shows when generated */}
      {qrValue && (
        <FormSection title="Scan QR Code">
          <Box display={"flex"} justifyContent={"center"} py={3}>
            <QRCode value={qrValue} />
          </Box>
        </FormSection>
      )}
    </Grid>
  );
}

export default MfaConfiguration;
